// extracted by mini-css-extract-plugin
export default {"kpiTagsContainer":"KpiTags_kpiTagsContainer__P0ahr","kpiTag":"KpiTags_kpiTag__TW2kB"};